import { PageModal } from './AccountModal'
import { AccountSectionWrapper, ANCHOR_TAGS, Separator } from './AccountSectionWrapper'
import { useToggle } from '../hooks/useToggle'
import { FormAddBrand } from './FormAddBrand'
import { useMemo } from 'preact/hooks'
import { brandOptions } from '../helpers/GlobalAssets'
import { accountTranslations } from '../helpers/translations'
const BRANDS_TEST = [
  'https://thrivemyway.com/wp-content/uploads/2022/03/Adidas-Logo-Shoe-Brands.png',
  'https://thrivemyway.com/wp-content/uploads/2022/03/Adidas-Logo-Shoe-Brands.png',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4yKxgB2mAwSkfemm95bwqk66gGkIPuGV0wA&s'
]
export const Bubble = ({ children }) => {
  return (
    <div className={'rounded-lg border border-solid bg-primary-white'}>
      <div className={'flex min-h-16 min-w-44 items-center justify-evenly p-4'}>{children}</div>
    </div>
  )
}

/**
 *
 * @param {{profile: any, connectionId: number}} param0
 * @returns
 */
export const AccountKidsProfileBrand = ({ profile, connectionId, handleRefetch }) => {
  const { isActive, handleToggle } = useToggle(false)
  const brands = profile.custom_attributes?.omneo?.brands ?? []
  const brandData = useMemo(() => {
    return brandOptions.reduce((acc, brand) => {
      acc[brand.value] = brand.icon
      return acc
    }, {})
  }, [])

  return (
    <AccountSectionWrapper
      anchorTag={ANCHOR_TAGS.FAVOURITE_BRANDS.tag}
      title={accountTranslations.kids_profiles.favourite_brands.title}
      cta={{
        title: accountTranslations.kids_profiles.favourite_brands.cta,
        icon: 'plus',
        callback: handleToggle,
        hook: ''
      }}
      showDivider={false}
    >
      <PageModal
        props={{
          isActive,
          handleToggle,
          modalTitle: accountTranslations.kids_profiles.favourite_brands.cta,
          modal: (
            <FormAddBrand
              handleRefetch={handleRefetch}
              connectionId={connectionId}
              handleToggle={handleToggle}
              brands={BRANDS_TEST}
              brandsMap={brandData}
              selectedBrands={brands}
            />
          )
        }}
      >
        <div class="flex flex-row flex-wrap gap-4 py-4">
          {brands.map((brand) => {
            const brandImage = brandData[brand]
            if (!brandImage) return <></>
            return (
              <Bubble>
                <div className={'aspect-1 max-h-8 w-16'}>
                  <img src={brandImage} className={'h-full w-full object-contain'} />
                </div>
              </Bubble>
            )
          })}
        </div>
        <Separator />
      </PageModal>
    </AccountSectionWrapper>
  )
}
